module.exports = __webpack_public_path__ + "img/qr_crew.44ba2e11.svg";